import bird0001 from '@/assets/avatars/profile-legacy/bird0001.svg';
import bird0002 from '@/assets/avatars/profile-legacy/bird0002.svg';
import bird0003 from '@/assets/avatars/profile-legacy/bird0003.svg';
import bird0004 from '@/assets/avatars/profile-legacy/bird0004.svg';
import cat0001 from '@/assets/avatars/profile-legacy/cat0001.svg';
import dog0001 from '@/assets/avatars/profile-legacy/dog0001.svg';
import giraffe0001 from '@/assets/avatars/profile-legacy/giraffe0001.svg';
import llama0001 from '@/assets/avatars/profile-legacy/llama0001.svg';
import panda0001 from '@/assets/avatars/profile-legacy/panda0001.svg';
import penguin0001 from '@/assets/avatars/profile-legacy/penguin0001.svg';
import rabbit0001 from '@/assets/avatars/profile-legacy/rabbit0001.svg';
import tiger0001 from '@/assets/avatars/profile-legacy/tiger0001.svg';

const Component = ({ avatar, alt }: { avatar: string; alt: string }) => {
  return <img src={avatar} alt={alt} />;
};

export const avatarMapLegacy = {
  bird0001: () => <Component avatar={bird0001} alt="avatar for bird0001" />,
  bird0002: () => <Component avatar={bird0002} alt="avatar for bird0002" />,
  bird0003: () => <Component avatar={bird0003} alt="avatar for bird0003" />,
  bird0004: () => <Component avatar={bird0004} alt="avatar for bird0004" />,
  cat0001: () => <Component avatar={cat0001} alt="avatar for cat0001" />,
  dog0001: () => <Component avatar={dog0001} alt="avatar for dog0001" />,
  giraffe0001: () => (
    <Component avatar={giraffe0001} alt="avatar for giraffe0001" />
  ),
  llama0001: () => <Component avatar={llama0001} alt="avatar for llama0001" />,
  panda0001: () => <Component avatar={panda0001} alt="avatar for panda0001" />,
  penguin0001: () => (
    <Component avatar={penguin0001} alt="avatar for penguin0001" />
  ),
  rabbit0001: () => (
    <Component avatar={rabbit0001} alt="avatar for rabbit0001" />
  ),
  tiger0001: () => <Component avatar={tiger0001} alt="avatar for tiger0001" />,
};

export type AvatarLegacyKey = keyof typeof avatarMapLegacy;
